import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Accordion from "./Accordion";
import AccordionFilterSearch from "./AccordionFilterSearch";
import Wrapper from '../wrapper/Wrapper';

var AccordionFilter = function AccordionFilter(props) {
  var _props$fields$items = props.fields.items,
      items = _props$fields$items === void 0 ? [] : _props$fields$items;

  var _useState = useState("all"),
      _useState2 = _slicedToArray(_useState, 2),
      filterKey = _useState2[0],
      setFilterKey = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1]; //obj in category array are => key.value is machine readable, value.value is human readable


  var CategoryMap = Array.isArray(items) ? items.map(function (category) {
    var _category$fields, _category$fields$valu, _category$fields2, _category$fields2$key;

    return {
      label: category === null || category === void 0 ? void 0 : (_category$fields = category.fields) === null || _category$fields === void 0 ? void 0 : (_category$fields$valu = _category$fields.value) === null || _category$fields$valu === void 0 ? void 0 : _category$fields$valu.value,
      value: category === null || category === void 0 ? void 0 : (_category$fields2 = category.fields) === null || _category$fields2 === void 0 ? void 0 : (_category$fields2$key = _category$fields2.key) === null || _category$fields2$key === void 0 ? void 0 : _category$fields2$key.value
    };
  }) : [];
  var CategoryArray = [{
    value: "all",
    label: "All"
  }].concat(_toConsumableArray(CategoryMap));
  var filteredItems = Array.isArray(items) ? items.filter(function (item) {
    return filterKey === "all" ? true : item.fields.key.value === filterKey;
  }) : [];
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: props.layout
  }, /*#__PURE__*/React.createElement(AccordionFilterSearch, {
    categories: CategoryArray,
    searchChange: function searchChange(e) {
      setSearchValue(e);
    },
    changeHandler: function changeHandler(e) {
      e.persist();
      setFilterKey(e.target.value);
    }
  }), filteredItems.map(function (item) {
    var value = item.fields.value;
    var titleModel = {
      title: value
    };
    var searchedItems = item.items.filter(function (a) {
      return searchValue === "" ? true : a.Title.value.toLowerCase().includes(searchValue.toLowerCase());
    });

    if (searchedItems.length <= 0) {
      return "";
    }

    var formattedItems = searchedItems.map(function (a) {
      return _objectSpread({
        fields: _objectSpread({}, a)
      }, a);
    });
    return /*#__PURE__*/React.createElement(Accordion, {
      model: formattedItems,
      title: titleModel
    });
  }));
};

export default AccordionFilter;